import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LelService {

  private readonly baseUrl = environment.APIEndpoint;

  constructor(
    private http: HttpClient) { }

  public getDataLogonSessao(): Observable<string> {
    const url = `${this.baseUrl}/lel/sessao`;
    return this.http.post(url, {}, { responseType: 'text' });
  }
}
